import React, { type ReactNode } from 'react';

import IntlMessagesProvider from '@atlaskit/intl-messages-provider/main';
import defaultMessages from '@atlassian/afm-i18n-platform-ai-mate-studio-browse-kit/i18n/en';

import { fetchMessagesForLocale } from './fetchLocaleMessage';

export const StudioBrowseKitIntlProvider = ({
	children,
}: {
	children: ReactNode;
}): React.JSX.Element => (
	<IntlMessagesProvider loaderFn={fetchMessagesForLocale} defaultMessages={defaultMessages}>
		{children}
	</IntlMessagesProvider>
);
